import { gql } from '@apollo/client';

export const PAGINATE_USERS = gql`
	query PaginateUsers(
		$first: Int! = 30
		$page: Int! = 1
		$search: String
	) {
		paginateUsers(
			first: $first
			page: $page
			search: $search
		) {
			paginatorInfo {
                count
                currentPage
                firstItem
                perPage
                lastItem
                total
            }
            data {
                id
                name
                email
				role {
					id
					name
				}
				created_at
            }
		}
	}
`;

export const GET_USER = gql`
	query GerUser(
		$id: String!
	) {
		getUser(
			id: $id
		) {
			id
			name
			email
			role {
				id
				name
			}
			created_at
		}
	}
`;

export const CREATE_USER = gql`
	mutation CreateUser(
		$input: CreateUserInput!
	) {
		createUser(
			input: $input
		) {
			id
			name
			email
			role {
				id
				name
			}
			created_at
		}
	}
`;


export const UPDATE_USER = gql`
	mutation UpdateUser(
		$input: UpdateUserInput!
	) {
		updateUser(
			input: $input
		) {
			id
			name
			email
			role {
				id
				name
			}
			created_at
		}
	}
`;